import IApplicationState from 'app/types/state';
import _ from 'lodash';
import { getPaymentCollectionIdsByPaymentId } from 'app/ducks/paymentCollections/selectors';

import { IPayment } from 'app/ducks/payments/types';

export const getPaymentCollectionIds = (state: IApplicationState, paymentId) => getPaymentCollectionIdsByPaymentId(state, paymentId);

export function getCurrentPayment(state: IApplicationState) {
  if (
    state.payments.paymentsById !== undefined
    && state.payments.currentPaymentId !== undefined
  ) {
    const findPayment = state.payments.paymentsById[state.payments.currentPaymentId];
    const currentPayment = {
      ...findPayment,
      paymentCollections: getPaymentCollectionIds(
        state,
        state.payments.currentPaymentId,
      ),
    };

    return currentPayment;
  }
  return {};
}

export function getPaymentsFilteredByClubById(paymentsById, clubId) {
  const filteredPayments = _.filter(paymentsById, {
    club: { id: clubId },
  });
  const paymentIds = _.map(filteredPayments, 'id');
  const parsedPaymentsById = _.pick(paymentsById, paymentIds);

  return {
    paymentsById: parsedPaymentsById,
    paymentIds,
  };
}
export function parsePaymentStatus(paymentStatus): string {
  let status = 'In Progress';
  switch (paymentStatus) {
    case 'collected':
      status = 'Paid';
      break;
    case 'cancelled':
      status = 'Cancelled';
      break;
    default:
      status = 'In Progress';
      break;
  }
  return status;
}

export function getPaymentSummary(payment: IPayment): any {
  const paymentSummary = {
    id: payment.id,
    summary: {
      description: payment.description,
      numberOfTeamMembers: payment.numberOfTeamMembers,
    },
    amount: payment.amount,
    status: payment.status,
    createdAt: payment.createdAt,
    collected: {
      collected: payment.collectedAmount,
      total: payment.totalAmount,
    },
    pendingTeamMembers: payment.pending,
  };
  return paymentSummary;
}

export function getCurrentFormPayment(state: IApplicationState) {
  return {
    ...getCurrentPayment(state),
    ...state.payments.requestedData,
  };
}

export function getPayments(state: IApplicationState) {
  return {
    ...state.payments,
    currentPayment: {
      ...getCurrentPayment(state),
    },
  };
}

export function getPaymentIdsByTeamId(paymentsById: any, teamId) {
  if (paymentsById !== undefined && teamId != null) {
    const filtered = _.filter(paymentsById, { teamId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
export function getPaymentIdsByClubId(paymentsById: any, clubId) {
  if (paymentsById !== undefined && clubId != null) {
    const filtered = _.filter(paymentsById, { clubId });
    if (filtered != null) {
      return _.map(filtered, 'id');
    }
    return [];
  }
  return [];
}
